class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      var gwp = '';
      if (this.dataset.gwp) {
        var data = await this.getProductVariant(this.dataset.gwp);
        if (data.data.product != null) {
          gwp = data.data.product.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', '')
        }
      }

      var gwpVariant = '';
      if (this.dataset.gwpVariant) {
        gwpVariant = parseInt(this.dataset.gwpVariant);
      }
      this.closest('cart-items').updateQuantity(this.dataset.index, 0, this.dataset.variant, '', gwp, gwpVariant);
    });
  }
  getProductVariant(id) {
    return fetch('https://dphue.myshopify.com/api/2022-07/graphql.json', {
        'method': 'POST',
        'headers': {
          'X-Shopify-Storefront-Access-Token': '281ab10ea01587e3c8c091633ee7ea2b',
          'Content-Type': 'application/json',
        },
        'body': JSON.stringify({
              query: `{
          product(id: "gid://shopify/Product/` + id + `") {
            id
            variants (first:1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }`
           })
    }).then(res => res.json())
      .then(data => {
        return data;
    }).catch(error => {
      console.log(error)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
  var total = this.getAttribute("data-total");
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    if ( total/100  > window.gift_with_purchase.threshold) {
        this.quantity = 1;
    } else {
        this.quantity = 0;
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, event.target.dataset.variant, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [      
      {
        id: 'cart-shipping-bar',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.shipping_bar',
      },
      {
        id: 'products-sample-wrapper',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.products-sample-wrapper',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, variant, name, gwp, gwpVariant) {
    this.enableLoading(line);
    quantity = parseInt(quantity)
    line = parseInt(line)
    
    if(localStorage.getItem('sample-product')) {
      if (variant == localStorage.getItem('sample-product')) {
        localStorage.removeItem('sample-product');
      }
    }
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then( async (state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
         
        }));

        slickCarousel();

        // Hide cart if no item in cart
        var remove_sample = false;
        if (parsedState.original_total_price == 0) {
          document.querySelector("[data-modal='#Slideout-cart']").innerHTML = "";
          document.querySelector('cart-drawer').hide();
          remove_sample = true;
          // removeSample();
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        const d = await this.checkGiftInCart(parsedState, this.quantity, remove_sample, gwp, gwpVariant);

      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      }).finally(() => {
        if(!document.querySelector('.header__icon--cart')) {
          if (typeof(Storage) !== 'undefined') {
            localStorage.removeItem('sample-product');
          }
        }
        if (document.getElementById('cart-icon-bubble')) {
          document.getElementById('cart-icon-bubble').bindALink();
        }
      });
  } 

  removeSample() {
    var body = {
      updates : {}
    }
    if(localStorage.getItem('sample-product')) {
        body.updates[localStorage.getItem('sample-product')] = 0;
        localStorage.removeItem('sample-product');
      }
    var data = fetch(window.routes.cart_update_url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(body)
    })
  }

  checkGiftInCart(data, quantity, remove_sample, gwp, gwpVariant) {
    var check = true;
    var body = {
      updates : {}
    }

    // checkGWPVariant
    if (gwpVariant) {
      var countGWP = 0;
      var gwpQuantity = 0;
      for (let i = 0; i < data.items.length; i++) {
        if (data.items[i].properties) {
          if (data.items[i].properties.gwpVariant == gwpVariant && data.items[i].properties.gwpVariant) {
            countGWP++;
          }
        }
      }
      body.updates[gwpVariant] = countGWP;
      if (data.items.length == 1 && countGWP == 0) {
        document.querySelector('cart-drawer').hide();
        if (document.getElementById('cart-icon-bubble')) {
          document.getElementById('cart-icon-bubble').bindALink();
        }
      }
    }
    // end check GWPVariant

    if (parseInt(data.original_total_price) /100 > parseInt(window.gift_with_purchase.threshold)) {
      if(this.quantity == 0) {
        this.quantity = 1;
      } else {
        // document.querySelector('cart-drawer').classList.remove('loading');
        // return;
        check = false

      }
    } else {
      this.quantity = 0;
    }
    
    var id = window.gift_with_purchase.gift_one
    var id2 = window.gift_with_purchase.gift_two
    
    if (gwp) {
      body.updates[gwp] = 0;
    }
    if (id != '' && check) {

      body.updates[id] = this.quantity;
    }
    if (id2 != '' && check) {
      body.updates[id2] = this.quantity;
    }

    if(this.quantity == 0) {
      localStorage.removeItem('gift-product');
      localStorage.removeItem('gift-product-2');
      localStorage.removeItem('gift-product-3');
      if(remove_sample) {
        if (localStorage.getItem('sample-product') != undefined) {
          body.updates[localStorage.getItem('sample-product')] = this.quantity;
          localStorage.removeItem('sample-product');
        }
      }
    }

    if (Object.keys(body).length === 0) {
      document.querySelector('cart-drawer').classList.remove('loading');
      return;
    }
    fetch(window.routes.cart_update_url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(body)
    }).then( res => document.querySelector('cart-drawer').updateCart())
    return true;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.querySelector('cart-drawer').classList.add('loading');
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);